<template>
  <modal @close="close">
    <md-toolbar :class="headerClass" md-elevation="1" slot="header">
      <h3>
        Iniciar Reparacion
        <span v-if="isLate || isAhead">
          ({{ Math.abs(daysDiff) }} dia{{ Math.abs(daysDiff) > 1 ? "s" : "" }}
          {{ isLate ? "despues" : "antes" }})
        </span>
        | {{ expected.sinisterNumber }}
      </h3>
    </md-toolbar>

    <form slot="body" id="real-form" @submit.prevent="save">
      <!-- <div class="md-layout-item md-size-50 md-xsmall-size-100">
        <div class="outlined-field-picker">
          <md-field :class="validationClass('finishDate')">
            <label class="active date-label">Fecha fin</label>
            <label class="picker-icon" for="dateOccurred">
              <md-icon>calendar_today</md-icon>
            </label>
            <datetime
              data-vv-name="finishDate"
              v-validate="'required'"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Desde"
              value-zone="America/Mexico_City"
              :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
              v-model="real.finishDate"
            ></datetime>
          </md-field>
        </div>
      </div>-->

      <image-input header="Primera Foto de seguridad:" @loadedImage="loadImage" />

      <md-content
        class="md-layout"
        style="margin-top: 8px;"
        :class="delayClass.content"
        v-if="isLate || isAhead"
      >
        <md-field>
          <label class="text-danger">Motivo del {{ isLate ? "atraso" : "adelanto" }}</label>
          <md-textarea v-model="real.delayReason" />
        </md-field>
      </md-content>
    </form>
    <div slot="footer">
      <md-button
        type="submit"
        class="md-primary"
        form="real-form"
        :disabled="
          !imageUploaded ||
          !real.finishDate ||
          ((isLate || isAhead) && !real.delayReason)
        "
      >Aceptar</md-button>
      <md-button @click="close">Cancelar</md-button>
    </div>
  </modal>
</template>

<script>
import { ImageInput } from "@/components";

export default {
  name: "Real",

  props: {
    expected: {
      type: Object,
      required: true,
    },
    daysDiff: {
      type: Number,
      default: 0,
      required: false,
    },
  },

  components: {
    ImageInput,
  },

  computed: {
    imageUploaded() {
      const firstPhoto = this.real.firstPhoto;
      const pType = typeof firstPhoto;
      return firstPhoto != null;
    },
    isLate() {
      return this.daysDiff < 0;
    },
    isAhead() {
      return this.daysDiff > 0;
    },
    delayClass() {
      if (this.isLate) {
        return { content: "delay-content", text: "text-danger" };
      } else if (this.isAhead) {
        return { content: "ahead-content", text: "text-info" };
      } else {
        return {};
      }
    },
    headerClass() {
      if (this.isLate) {
        return "md-danger";
      } else if (this.isAhead) {
        return "md-info";
      } else {
        return "md-success";
      }
    },
  },

  data() {
    return {
      real: {
        startDate: null,
        finishDate: null,
        finishWorkingHours: null,
        firstPhoto: null,
        expected: null,
        delayReason: null,
      },
    };
  },

  watch: {
    expected: {
      immediate: true,
      handler(expected) {
        const finishDate = `${expected.finishDate}`;
        const real = {
          ...this.real,
          planExpected: expected.id,
          finishDate: finishDate,
        };
        this.real = real;
      },
    },
    isLate: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$notify({
            message: "Se esta iniciando la reparacion tarde.",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        }
      },
    },
    "real.firstPhoto": function () {},
  },

  mounted() {
    this.watchTouched({ real: Object.keys(this.real) });
  },

  methods: {
    loadImage(file) {
      this.real.firstPhoto = file;
    },
    close() {
      this.$emit("close");
    },
    save() {
      const real = this.real;

      this.validateAll().then(() => this.$emit("saved", real));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.delay-content {
  background: md-get-palette-color(red, 100) !important;
}

.ahead-content {
  background: md-get-palette-color(blue, 100) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/Real.vue